'use strict'
/**
 * Model for component Navbar
 * @returns nothing
 */

class Model {
}

export default Model